module.exports = __webpack_public_path__ + "static/propins-fe18a0ef22be8812131d7c76c1746acb.png";